var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "90324d73-5838-4221-982d-f6a287687ffa",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon5",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon5",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/c61d20c8-ce40-4e8f-bd0f-e94515091f3c/db69e5d94bb80ce142942055905bfcbf5c16445a/",
    core: "4.5.1",
    title: "Deco1",
    type: "haiku",
    relpath: "code/deco1/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco1-b2dcea53f1bacc28": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 11.558,
        "sizeAbsolute.y": 10.882,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:c99c19f1270d": {
        "sizeAbsolute.y": 8,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 9,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 5.783999999999999,
        "translation.y": 5.604999999999999,
        "style.zIndex": 3,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:dfc0f429bbe5": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:57cc3bc9c689": { fill: "#F75D4A", "translation.y": -20 },
      "haiku:df711e8cebae": {
        x: 1.32893795,
        y: 21.0146654,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": -16.83812,
        "translation.y": 11.86199,
        "rotation.z": 5.410521
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco1-b2dcea53f1bacc28",
      "haiku-title": "Deco1"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "c99c19f1270d",
          "haiku-title": "deco1",
          "haiku-source":
            "designs/AnimatorWebsiteIcon5.sketch.contents/slices/deco1.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "dfc0f429bbe5",
              "haiku-title": "Page-1",
              id: "a6d1a92b457e"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "57cc3bc9c689",
                  "haiku-title": "Docs-icon",
                  id: "0225fe8bde48"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "df711e8cebae",
                      "haiku-title": "deco1",
                      id: "c008e8ddfe68"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon5/code/deco1/code.js
// module id = 448
// module chunks = 127651196306611